import axios from "axios";
import { useItemStore } from "@/itemStore";
import type { Item } from "@/itemStore";

const baseUrl = import.meta.env.DEV
  ? "https://localhost/wp-json/jcore/v1/"
  : "/wp-json/jcore/v1/";

export interface Response {
  (data: any): void;
}

type SearchResponse = {
  total: number,
  items: Array<Item>,
}

type Params = {
  lang: string;
  primary?: string;
  secondary?: string;
  search?: string;
  sort?: string;
  order?: string;
  page?: number;
  year?: number;
  month?: number;
  posts?: number;
};

export const searchPosts = () => {
  const itemStore = useItemStore();

  const params: Params = {
    lang: itemStore.lang,
    primary: itemStore.filter.primary.join(),
    secondary: itemStore.filter.secondary.join(),
    search: itemStore.search,
    sort: itemStore.sort,
    order: itemStore.asc ? "asc" : "desc",
    page: itemStore.page,
    posts: itemStore.perPage,
  };
  axios
    .get(baseUrl + "search/" + itemStore.type, { params })
    .then((response) => {
      // Loop all response items and add them to store.
      (response.data as SearchResponse).items.forEach((item) => {
        itemStore.addItem(item);
      });
      // Update total only if it's above 0, or page is 1.
      if (response.data.total > 0 || response.data.page < 2) {
        itemStore.total = response.data.total;
      }
      if (response.data.total === 0) {
        // Don't do any more automatic page fetches for this query.
        itemStore.page = 0;
      }
    })
    .catch((reason) => {
      console.debug(reason);
    });
};

export const fetchTerms = (taxonomy: string) => {
  const itemStore = useItemStore();

  const params: Params = {
    lang: itemStore.lang,
  };

  axios
    .get(baseUrl + "terms/" + taxonomy, { params })
    .then((response) => {
      itemStore.addTerms(response.data.terms, taxonomy);
    })
    .catch((reason) => {
      console.debug(reason);
    });
};

export const fetchMonth = () => {
  const itemStore = useItemStore();

  const params = {
    lang: itemStore.lang,
  };
  axios
    .get(baseUrl + "months/" + itemStore.type, { params })
    .then((response) => {
      itemStore.months = response.data;
    })
    .catch((reason) => {
      console.debug(reason);
    });
};
